import { getAucklandISOString } from "./utils";

// Get cookie by name
export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
};

// Get HubSpot cookie
export const getHubspotUTK = () => {
  return getCookie("hubspotutk");
};

// Clears the hubspotutk cookie (FV2-946), called on sign-out, so the next visitor on this
// browser — a different real person on a shared device, or the next manual test signup —
// gets a fresh HubSpot visitor identity instead of inheriting this session's, which would
// otherwise get every later form submission from this browser cross-linked to this one.
// HubSpot's own tracking script sets the cookie's Domain itself (varies by environment: the
// bare host on localhost, a leading-dot root domain in prod), so this clears every variant
// rather than guessing one — an expired write against a domain that doesn't match the
// cookie's real one is a harmless no-op.
export const clearHubspotUTK = () => {
  const expired = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
  const host = window.location.hostname;
  const labels = host.split(".");
  const rootDomain = labels.length > 1 ? labels.slice(-2).join(".") : host;

  document.cookie = `hubspotutk=; ${expired}; path=/`;
  new Set([host, `.${host}`, rootDomain, `.${rootDomain}`]).forEach(
    (domain) => {
      document.cookie = `hubspotutk=; ${expired}; path=/; domain=${domain}`;
    }
  );
};

// Context for the HubSpot Forms API submission (FV2-604): lets HubSpot stitch a new
// contact to this browser's tracked session. hutk is omitted (not empty-stringed) when
// absent so the submission still succeeds — just without session stitching.
export const buildHubspotFormContext = () => {
  const hutk = getHubspotUTK();

  return {
    ...(hutk ? { hutk } : {}),
    pageUri: window.location.href,
    pageName: document.title
  };
};

// Extract UTM params from URL
export const getUTMParams = () => {
  const params = new URLSearchParams(window.location.search);

  return {
    utmSource: params.get("utm_source") || "",
    utmMedium: params.get("utm_medium") || "",
    utmCampaign: params.get("utm_campaign") || "",
    utmTerm: params.get("utm_term") || "",
    utmContent: params.get("utm_content") || "",
    utmMarket: params.get("utm_market") || ""
  };
};

// Store UTM params (call once on app load)
export const storeUTMParams = () => {
  const utm = getUTMParams();

  // Only store if at least one value exists
  if (Object.values(utm).some(Boolean)) {
    localStorage.setItem("utmData", JSON.stringify(utm));
  }
};

// Get stored UTM params
export const getStoredUTMParams = () => {
  return JSON.parse(localStorage.getItem("utmData")) || {};
};

// Build utmHistory payload
export const buildUtmHistory = () => {
  const stored = getStoredUTMParams();

  return [
    {
      utmSource: stored.utmSource || "",
      utmMedium: stored.utmMedium || "",
      utmCampaign: stored.utmCampaign || "",
      utmTerm: stored.utmTerm || "",
      utmContent: stored.utmContent || "",
      utmMarket: stored.utmMarket || "",
      visitTime: getAucklandISOString()
    }
  ];
};
